import 'font-awesome/css/font-awesome.min.css';
import 'antd/dist/antd.css';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import Modal from 'react-modal';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import MainModal from './components/AdvisorRegister/MainModal';
import AuthPages from './components/AuthPages/AuthPages';
import PrivateRoute from './components/AuthPages/PrivateRoute';
import DialogAlert from './components/DialogAlert/DialogAlert';
import ForgotAfterEmailScreen from './components/ForgotPasswordNew/ForgotAfterEmailScreen';
import StaticPages from './components/StaticPages/StaticPages';
import AppBanner from './Utils/AppBanner/AppBanner';
import AdminPages from './components/AdminDashboard/AdminPages';
import BlogEditor from './components/AdminDashboard/BlogEditor';
import NewsletterEditor from './components/AdminDashboard/NewsletterEditor';
import AdminRoute from './components/AuthPages/AdminRoute';
import ConfirmUnsubscribe from './components/unsubscribe/ConfirmUnsubscribe';
import Unsubscribe from './components/unsubscribe/Unsubscribe';
import { SendAlert, store } from '@plootus/common';
import Loader from './components/Loader';

Modal.setAppElement('#root');

// RouteWrapper component to handle scroll before rendering
const RouteWrapper = ({ component: Component }) => {
  const [isReady, setIsReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Reset states on mount
    setIsReady(false);
    setIsLoading(true);

    // Scroll to top
    window.scrollTo(0, 0);

    // First delay to ensure scroll completes
    const scrollTimer = setTimeout(() => {
      setIsReady(true);

      // Second delay to simulate minimal loading time and prevent flashing
      const loadingTimer = setTimeout(() => {
        setIsLoading(false);
      }, 300); // Adjust this time as needed

      return () => clearTimeout(loadingTimer);
    }, 100);

    return () => clearTimeout(scrollTimer);
  }, []);

  if (!isReady || isLoading) {
    return <Loader />;
  }

  return <Component />;
};

function App(props) {
  const location = useLocation();
  const [isRouteChanging, setIsRouteChanging] = useState(false);

  // Handle route changes
  useEffect(() => {
    setIsRouteChanging(true);
    window.scrollTo(0, 0);

    // Reset route change state after a delay
    const timer = setTimeout(() => {
      setIsRouteChanging(false);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="App">
      {isRouteChanging && <Loader />}
      <SendAlert render={(props) => <DialogAlert {...props} />} />
      {isMobile && <AppBanner />}
      <Routes>
        {/* // Developed and managed by Mejona technology */}
        <Route
          path="/auth/*"
          element={
            <PrivateRoute>
              <RouteWrapper component={AuthPages} />
            </PrivateRoute>
          }
        />
        <Route
          path="/forgot"
          element={<RouteWrapper component={ForgotAfterEmailScreen} />}
        />
        <Route
          path="/confirm-unsubscribe"
          element={<RouteWrapper component={ConfirmUnsubscribe} />}
        />
        <Route
          path="/unsubscribe"
          element={<RouteWrapper component={Unsubscribe} />}
        />
        <Route
          path="/advisor"
          element={<RouteWrapper component={MainModal} />}
        />
        <Route
          path="/admin/*"
          element={<RouteWrapper component={AdminPages} />}
        />
        <Route
          path="/admin/blog/:slug"
          element={
            <AdminRoute>
              <RouteWrapper component={BlogEditor} />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/newsletter/:slug"
          element={
            <AdminRoute>
              <RouteWrapper component={NewsletterEditor} />
            </AdminRoute>
          }
        />
        <Route
          path="*"
          element={<RouteWrapper component={StaticPages} />}
        />
      </Routes>
    </div>
  );
}

export default App;
